// extracted by mini-css-extract-plugin
module.exports = {"productBottle":"ProductBottleImage_productBottle__uQUY9"};